import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'
import { Option } from 'common-components'

@Component({
  selector: 'app-plan-renderer',
  template: ` <span title="{{ planName }}">{{ planName }}</span> `,
  standalone: false
})
export class PlanRendererComponent implements AgRendererComponent {
  private params: any
  private plansList: Option[]
  public planName: string

  agInit(params: any): void {
    this.params = params
    this.plansList = params.context.plansList

    if (params.data['PlanIds']) {
      const filteredPlans = this.plansList.filter(x =>
        params.data['PlanIds'].includes(x.id as string)
      )
      const planNamesArray = filteredPlans.map((item: any) => {
        return item.text
      })

      this.planName = planNamesArray.join(', ')
    }
  }

  refresh(params: any): boolean {
    return false
  }
}
